import makeStyles from '@mui/styles/makeStyles';
import React from "react";

const GLASS = 'M96 40c0 30 22 36 22 50s-22 20-22 50h48c0-30-22-36-22-50s22-20 22-50z';
const SPARKLE = 'l2 5 5 2-5 2-2 5-2-5-5-2 5-2z';

// One cycle: the top drains into the bottom, then the glass flips with the
// sand inside. Flipped, the bottom pile sits against the top cap, so the next
// cycle opens with that same pile sliding down onto the neck — no jump.
const useStyles = makeStyles({
  glass: {
    transformOrigin: '120px 90px',
    animation: '$flip 6s cubic-bezier(.65, 0, .35, 1) infinite',
  },
  top: {
    animation: '$drain 6s infinite',
  },
  bottom: {
    animation: '$fill 6s cubic-bezier(.3, 0, .6, 1) infinite',
  },
  stream: {
    strokeDasharray: '2 3',
    animation: '$trickle .4s linear infinite, $pour 6s linear infinite',
  },
  sparkle: {
    transformBox: 'fill-box',
    transformOrigin: '50% 50%',
    animation: '$twinkle 2.4s ease-in-out infinite',
  },
  '@keyframes flip': {
    '0%, 84%': {transform: 'rotate(0)'},
    '97%, 100%': {transform: 'rotate(180deg)'},
  },
  '@keyframes drain': {
    '0%': {transform: 'translateY(0)', animationTimingFunction: 'cubic-bezier(.5, 0, .8, .6)'},
    '7%': {transform: 'translateY(12px)', animationTimingFunction: 'linear'},
    '80%, 100%': {transform: 'translateY(72px)'},
  },
  '@keyframes fill': {
    '0%, 7%': {transform: 'translateY(40px)'},
    '80%, 100%': {transform: 'translateY(0)'},
  },
  '@keyframes trickle': {
    to: {strokeDashoffset: -5},
  },
  '@keyframes pour': {
    '0%, 6%': {opacity: 0},
    '8%, 77%': {opacity: 1},
    '79%, 100%': {opacity: 0},
  },
  '@keyframes twinkle': {
    '0%, 100%': {transform: 'scale(.5)', opacity: .3},
    '50%': {transform: 'scale(1.1)', opacity: 1},
  },
  '@media (prefers-reduced-motion: reduce)': {
    glass: {animation: 'none'},
    top: {animation: 'none', transform: 'translateY(30px)'},
    bottom: {animation: 'none', transform: 'translateY(26px)'},
    stream: {animation: 'none'},
    sparkle: {animation: 'none'},
  },
});

const HourglassArt = ({className}) => {
  const classes = useStyles();

  return (
    <svg className={className} viewBox="30 6 180 168" fill="none" stroke="#2B3A55" strokeWidth={3}
         strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <defs>
        <clipPath id="hourglassTop"><path d="M96 42c0 28 22 34 22 48h4c0-14 22-20 22-48z"/></clipPath>
        <clipPath id="hourglassBottom"><path d="M118 90c0 14-22 20-22 48h48c0-28-22-34-22-48z"/></clipPath>
      </defs>
      <circle cx={120} cy={90} r={80} fill="#FFF6E5" stroke="none"/>
      <path className={classes.sparkle} d={`M70 50${SPARKLE}`} fill="#fff" strokeWidth={1.8}/>
      <path className={classes.sparkle} style={{animationDelay: '1.2s'}} d={`M172 120${SPARKLE}`} fill="#fff"
            strokeWidth={1.8}/>
      <ellipse cx={120} cy={160} rx={34} ry={4} fill="#2B3A55" opacity={0.08} stroke="none"/>
      <g className={classes.glass}>
        <path d={GLASS} fill="#EAF6FE" stroke="none"/>
        <g clipPath="url(#hourglassTop)">
          <path className={classes.top} d="M90 20H150V74Q120 88 90 74Z" fill="#F6C343" stroke="none"/>
        </g>
        <g clipPath="url(#hourglassBottom)">
          <path className={classes.stream} d="M120 90v52" stroke="#E0A92E" strokeWidth={2}/>
          <path className={classes.bottom} d="M90 106Q120 92 150 106V170H90Z" fill="#F6C343" stroke="none"/>
        </g>
        <path d={GLASS}/>
        <path d="M104 52c0 14 8 22 12 28" stroke="#fff" strokeWidth={2.5} opacity={0.8}/>
        <rect x={88} y={32} width={64} height={10} rx={4} fill="#F08A6E"/>
        <rect x={88} y={138} width={64} height={10} rx={4} fill="#F08A6E"/>
      </g>
    </svg>
  );
};

export default HourglassArt;
